import Pusher from "pusher-js";
import { getAuthToken } from "./api";

let instance = null;

export const getPusher = () => {
  if (instance) return instance;

  Pusher.logToConsole = true; // remove after debugging

  console.log("[Pusher] Creating admin client", {
    key: process.env.REACT_APP_PUSHER_KEY,
    cluster: process.env.REACT_APP_PUSHER_CLUSTER,
    authEndpoint: process.env.REACT_APP_PUSHER_AUTH_ENDPOINT,
  });

  instance = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
    cluster: process.env.REACT_APP_PUSHER_CLUSTER,
    authorizer: (channel) => ({
      authorize: (socketId, callback) => {
        const token = getAuthToken();
        fetch(process.env.REACT_APP_PUSHER_AUTH_ENDPOINT, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            socket_id: socketId,
            channel_name: channel.name,
          }),
        })
          .then((res) => {
            if (!res.ok) {
              throw new Error(`Auth request failed with status ${res.status}`);
            }
            return res.json();
          })
          .then((data) => callback(null, data))
          .catch((err) => {
            console.error(`[Pusher] auth failed for "${channel.name}":`, err);
            callback(err, null);
          });
      },
    }),
  });

  instance.connection.bind("state_change", (states) => {
    console.log(`[Pusher] connection state: ${states.previous} -> ${states.current}`);
  });

  instance.connection.bind("connected", () => {
    console.log("[Pusher] connected. socket_id:", instance.connection.socket_id);
  });

  instance.connection.bind("error", (err) => {
    console.error("[Pusher] connection error:", err);
  });

  return instance;
};

export const subscribeToChannel = (channelName) => {
  const pusher = getPusher();
  const channel = pusher.subscribe(channelName);

  channel.bind("pusher:subscription_succeeded", () => {
    console.log(`[Pusher] subscribed to "${channelName}"`);
  });

  channel.bind("pusher:subscription_error", (status) => {
    console.error(`[Pusher] subscription to "${channelName}" failed:`, status);
  });

  return channel;
};

export const disconnectPusher = () => {
  if (instance) {
    console.log("[Pusher] disconnecting client");
    instance.disconnect();
    instance = null;
  }
};
